function getListSegment(segment) {
    switch (segment) {
        case "user":
            return "my";
        case "team":
            return "team";
        case "company":
            return "companyTeam";
        case "all":
            return "custom";
        default:
            return "custom";
    }
}

function getListCustomFilter(query) {
    if (!query) {
        return {};
    }

    return {
        filterSet: Object.values(query).some(Boolean),

        localTeams: query.localTeams?.split(",") ?? [],
        tags: query.tags?.split(",") ?? [],
        cycles: query.cycles?.split(",") ?? [],
        states: query.states?.split(",") ?? [],
        users: query.users?.split(",") ?? [],
        keyword: query.keyword ?? "",
        admin: query.admin?.split(",") ?? [],
        ownerType: query.ownerType?.split(",") ?? [],
        purpose: query.purpose?.split(",") ?? [],
    };
}

export default {
    getListSegment,
    getListCustomFilter,
};

export { getListSegment, getListCustomFilter };
